export default __webpack_public_path__ + "static/termite-7129e3b11026769d0ae36a30968b5651.png";